/**
 * Created by glesouchu on 03.03.2015.
 */

import { ExternalLoggingConstants } from "../ExternalLoggingConstants";
import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";

export class GameVersionErrorFactory extends BasicLogObjectFactory {
    public static BASIC_LOADER_DATA_NOT_SUPPORTED: string = "Cache Breaker doesn't support basic loader data.";
    public static CACHE_BREAKER_DATA_NOT_SUPPORTED: string = "Game doesn't support cache breaker data.";
    private static EVENT_ID: number = 60;

    protected GAME_ID: string = "gameId";
    protected ERROR_MESSAGE: string = "errorMessage";

    protected _gameId: number;
    protected _errorMessage: string;

    constructor(gameID: number, errorMessage: string) {
        super();

        this._gameId = gameID;
        this._errorMessage = errorMessage;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, GameVersionErrorFactory.EVENT_ID.toString());
        lo.logData.set(this.GAME_ID, this._gameId.toString());
        lo.logData.set(this.ERROR_MESSAGE, this._errorMessage);

        return lo;
    }
}
